module.exports = __webpack_public_path__ + "img/Logo_Easy_Software.6fb0d6ad.svg";